import { defineMessages } from "react-intl";

const HEADER = "header";

const headerMessages = defineMessages({
  ebscoLogo: {
    id: `${HEADER}.ebsco-logo`,
    defaultMessage: "EBSCO logo"
  },
  ebscoSupportSite: {
    id: `${HEADER}.ebsco-support-site`,
    defaultMessage: "EBSCO support site"
  }
});

export default headerMessages;
